import {Stack, Typography} from "@mui/material";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {LeftArrowIcon, RightArrowIcon} from "@ui/icons/icons";
import {emptyPaginationSx} from './sx'
import {SetStatePropsType} from "@baseTypes/base";


interface IProps {
    page: number,
    setPage: SetStatePropsType<number>,
    disabled?: boolean,
    totalPage?: number
}

const EmptyPagination = ({
                             page,
                             setPage,
                             disabled,
                             totalPage
                         }: IProps) => {
    const disabledNext = typeof totalPage !== 'undefined' ? page >= totalPage : false

    return (
        <Stack
            sx={emptyPaginationSx.root}
            direction={'row'}
            alignItems={'center'}
        >
            <IconButtonCustom
                onClick={() => setPage((prev) => prev - 1)}
                disabled={disabled || page === 1}
                sx={emptyPaginationSx.button}
            >
                <LeftArrowIcon
                    color={(disabled || page === 1) ? '#0000001a' : '#696464de'}
                />
            </IconButtonCustom>

            <IconButtonCustom
                color={'#00000014'}
                disabled={true}
                sx={emptyPaginationSx.button}
            >
                <Typography
                    sx={emptyPaginationSx.pageCount}
                    variant={'caption'}
                >
                    {page}
                </Typography>
            </IconButtonCustom>

            <IconButtonCustom
                disabled={disabled || disabledNext}
                onClick={() => setPage((prev) => prev + 1)}
                sx={emptyPaginationSx.button}
            >
                <RightArrowIcon
                    color={disabled ? '#0000001a' : '#696464de'}
                />
            </IconButtonCustom>
        </Stack>
    );
};

export default EmptyPagination;
